<template>
    <div class="page">
      <div class="head-title">
        <div class="left">
          <ul class="breadcrumb">
            <li>
              <a href="#" class="active">{{ $t("Property") }}</a>
            </li>
            <li>-</li>
            <li>
              <router-link to="/property/allpayment" class="active">{{ $t("orders") }} {{ $t("payment") }} /
                {{ $t("collection") }}</router-link>
            </li>
            <li>-</li>
            <li>
              <a href="#" class="active">{{ $t("update") }} {{ $t("payment") }} / {{ $t("collection") }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="main">
        <div class="head">
          <div class="head1">
            <h3>
              <i class="bi bi-credit-card"></i> {{ $t("update") }} {{ $t("payment") }} /
              {{ $t("collection") }}
            </h3>
          </div>
          <div class="head2">
            <button class="buttonconfirm" type="submit" :disabled="isSubmitting" @click="submit">
              {{ $t("save") }}
            </button>
          </div>
        </div>
        <div class="body">
          <div v-if="error" class="error">{{ error }}</div>
          <div v-else-if="isLoading">Loading...</div>
          <div v-else-if="contstatus!=='waiting'">لا يمكنك التحديث</div>

          <div v-else>
            <div class="body1">
              <div class="group">
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("renter") }}
                    <span class="error-feedback" v-if="v$.renter.$error">*</span></label>
                  <div class="col-sm-7">
                    <v-select :options="renters" label="rentername" v-model="renter" :disabled="true">
                      <template #option="option">
                        <div class="option">
                          <span>{{ option.rentername }}</span>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("realty") }}
                    <span class="error-feedback" v-if="v$.property.$error">*</span></label>
                  <div class="col-sm-7">
                    <v-select :options="properties" label="name" v-model="property" :disabled="true">
                      <template #option="option">
                        <div class="option">
                          <span>{{ option.name }}</span>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("contract") }}
                    <span class="error-feedback" v-if="v$.contract.$error">*</span></label>
                  <div class="col-sm-7">
                    <v-select :options="contracts" label="rentername" v-model="contract" :disabled="true">
                      <template #option="option">
                        <div class="option">
                          <span>{{ option.rentername }} - {{ $t("unit") }} {{ option.unite }}</span>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="group">
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("status") }} {{ $t("contract") }}</label>
                  <div class="col-sm-4">
                    <div type="text" class="form-control" disabled>{{ $t(contstatus) }}</div>
                  </div>
                </div>
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("type") }} {{ $t("contract") }}</label>
                  <div class="col-sm-4">
                    <div type="text" class="form-control" disabled>{{ $t(conttype) }}</div>
                  </div>
                </div>
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("date") }} {{ $t("start") }} {{ $t("contract") }}</label>
                  <div class="col-sm-4">
                    <div type="text" class="form-control" disabled>{{ $t(contstart) }}</div>
                  </div>
                </div>
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("type") }} {{ $t("Commission") }} {{ $t("collection") }}</label>
                  <div class="col-sm-4">
                    <select type="number" class="form-control" v-model="commissiontype" disabled>
                      <option value="1">العمولة شامل الضريبة</option>
                      <option value="2">العمولة غير شامل الضريبة</option>
                    </select>
                  </div>
                </div>
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("duration") }} {{ $t("contract") }}</label>
                  <div class="col-sm-4">
                    <div type="text" class="form-control" disabled>{{ $t(contduration) }} شهر</div>
                  </div>
                </div>
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("amount") }} {{ $t("contract") }}</label>
                  <div class="col-sm-4">
                    <div type="text" class="form-control" disabled>{{ $t(contamount) }}</div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="body1">
              <div class="group">
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("Method of Payment") }}
                    <span class="error-feedback" v-if="v$.Method.$error">*</span></label>
                  <div class="col-sm-7">
                    <v-select :options="methods" label="category" v-model="Method">
                      <template #option="option">
                        <div class="option">
                          <span>{{ option.category }}</span>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="mb-1 row" v-if="Method.value != 'igar'">
                  <label class="col-sm-2 col-form-label">{{ $t("Account") }} {{ $t("payment") }}
                    <span class="error-feedback" v-if="v$.account.$error">*</span></label>
                  <div class="col-sm-7">
                    <v-select :options="accountpayment" label="namear" v-model="account">
                      <template #option="option">
                        <div class="option">
                          <span>{{ option.namear }}</span>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="mb-1 row" v-if="Method.value == 'igar'">
                  <label class="col-sm-2 col-form-label">الرقم المرجعى</label>
                  <div class="col-sm-7">
                    <input type="text" v-model="igarref" class="form-control" />
                  </div>
                </div>
              </div>
              <div class="group">
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("date") }} {{ $t("payment") }}
                    <span class="error-feedback" v-if="v$.paymentdate.$error">*</span></label>
                  <div class="col-sm-4">
                    <input type="date" class="form-control" v-model="paymentdate" />
                  </div>
                </div>
                <div class="mb-1 row">
                  <label class="col-sm-2 col-form-label">{{ $t("conductor") }}</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" v-model="conductor" />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="body1">
              <div class="group">
                <div class="mb-2 row">
                  <label class="col-sm-2 col-form-label-sm">
                    <i class="bi bi-pin-angle-fill"></i> {{ $t("add") }} {{ $t("attachments") }}
                  </label>
                  <div class="col-sm-8">
                    <div>
                      <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" />
                      <br />
                      <table class="table" style="width: 100%">
                        <thead>
                          <tr>
                            <th>{{ $t("name") }}</th>
                            <th>{{ $t("cancel") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(file, key) in fileURL" :key="file.name">
                            <td>{{ file.name }}</td>
                            <td>
                              <a href="#" class="remove-file" v-on:click="removeFile(key, 'fileURL')">
                                <i class="bi bi-x-circle-fill"></i>
                              </a>
                            </td>
                          </tr>
                          <tr v-for="(file, key) in newFiles" :key="'new-' + file.name">
                            <td>{{ file.name }}</td>
                            <td>
                              <a href="#" class="remove-file" v-on:click="removeFile(key, 'newFiles')">
                                <i class="bi bi-x-circle-fill"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="group">
              <br />
              <h5>الاقساط المتبقية</h5>
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th>مبلغ القسط</th>
                    <th>المطلوب سدادة</th>
                    <th>تاريخ الاستحقاق</th>
                    <th>مبلغ السداد</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="y in installment" :key="y">
                    <td>
                      <input type="checkbox" v-model="y.check" id="flexCheckDefault" @change="
                        if (y.check == true) {
                          y.payamount = Number(y.change);
                          colinstall();
                        } else {
                          y.payamount = 0;
                          colinstall();
                        }
                      " />
                    </td>
                    <td>{{ y.dueamount }}</td>
                    <td>{{ y.change }}</td>
                    <td>{{ y.duedate }}</td>
                    <td>
                      <input type="text" v-model="y.payamount" @change="colinstall" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="group">
              <br />
              <h5>العمولات</h5>
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th>العمولة</th>
                    <th>تاريخ الاستحقاق</th>
                    <th>نسبة العمولة</th>
                    <th>مبلغ العمولة</th>
                    <th>ضريبة العملة</th>
                    <th>المبلغ</th>
                    <th>مدفوع</th>
                    <th>المتبقى</th>
                    <th>دفع</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="y in commission" :key="y">
                    <td>
                      <input type="checkbox" v-model="y.check" id="flexCheckDefault" @change="
                        if (y.check == true) {
                          y.paymentamount = Number(y.amount - y.paied);
                          y.taxamount = Number(
                            y.paymentamount -
                            y.paymentamount / Number(1 + '.' + y.tax)
                          ).toFixed(2);
                          calcommission();
                        } else {
                          y.paymentamount = 0;
                          y.taxamount = 0;
                          calcommission();
                        }
                      " />
                    </td>
                    <td>{{ y.name }}</td>
                    <td>{{ y.duedate }}</td>
                    <td>{{ y.num }} %</td>
                    <td>{{ y.comamount }}</td>
                    <td>{{ y.tax }} %</td>
                    <td>{{ y.amount }}</td>
                    <td>{{ y.paied }}</td>
                    <td>{{ y.amount - y.paied }}</td>
                    <td>
                      <input type="text" class="form-control" @change="
                        y.taxamount = Number(
                          y.paymentamount -
                          y.paymentamount / Number(1 + '.' + y.tax)
                        ).toFixed(2);
                        calcommission();
                      " v-model="y.paymentamount" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="group">
              <br />
              <h5>{{ $t("details") }}</h5>
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th>مبلغ سداد الايجار السنوى</th>
                  <th>قيمة الضريبة 15%</th>
                  <th>اجمالى العمولات</th>
                  <th>اجمالى الضرايب على العمولات</th>
                  <th>عمولة التحصيل</th>
                  <th>الاجمالى</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ Number(totalrentpayment).toFixed(2) }}</td>
                  <td>{{ Number(totalrentpaymenttax).toFixed(2) }}</td>
                  <td>{{ Number(totalcommission - totalcommissiontax).toFixed(2) }}</td>
                  <td>{{ Number(totalcommissiontax).toFixed(2) }}</td>
                  <td v-if="this.commissiontype == 2">
                    {{ Number((totalrentpayment * comm) / 100).toFixed(2) }}
                  </td>
                  <td v-if="this.commissiontype == 1">
                    {{
                      Number(
                        ((Number(totalrentpayment) + Number(totalrentpaymenttax)) * comm) / 100
                      ).toFixed(2)
                    }}
                  </td>
                  <td style="border: 2px solid black">
                    {{
                      Number(totalrentpayment) +
                      Number(totalrentpaymenttax) +
                      Number(totalcommission)
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import vSelect from "vue-select";
  import axios from "axios";
  import store from "@/store";
  import Swal from "sweetalert2";
  import { mapActions } from "vuex";
  import { required } from "@vuelidate/validators";
  import useValidate from "@vuelidate/core";

  export default {
    props: {
      css: {
        type: Object,
        default: () => ({
          light: '#f9f9f9',
          dark: '#342e37',
          EN: 'rtl',
          AR: 'ltr',
          dirn: 'right',
          dir: 'ltr',
        }),
      },
      collid: {
        type: [String, Number],
        required: true,
      },
    },
    components: {
      vSelect,
    },
    async mounted() {
      this.isLoading = true;
      try {
        console.log('Mounted started, collid:', this.collid, 'route collid:', this.$route.params.collid);

        // Use collid from prop or fallback to route params
        const collid = this.collid || this.$route.params.collid;
        if (!collid) {
          console.error('No collid provided');
          this.error = this.$t('updatePayment.invalidCollid');
          return;
        }

        // Fetch payment details
        console.log('Fetching payment for collid:', collid);
        const paymentResult = await axios.get(`/data/getpayment/${collid}`);
        console.log('Payment result:', paymentResult.data);
        if (paymentResult.status === 200 && paymentResult.data.status === 'success') {
          const paymentData = paymentResult.data.data[0];
          if (!paymentData) {
            console.error('No payment data returned');
            this.error = this.$t('updatePayment.noData');
            return;
          }
          this.populatePaymentData(paymentData);
        } else {
          console.error('Payment API failed:', paymentResult.data);
          this.error = this.$t('updatePayment.noData');
          return;
        }

        // Fetch renters
        console.log('Fetching renters');
        const resultRenters = await axios.get("/data/getallrenters");
        console.log('Renters result:', resultRenters.data);
        if (resultRenters.status === 200 && resultRenters.data.status === 'success') {
          this.renters = resultRenters.data.data || [];
        } else {
          console.error('Renters API failed:', resultRenters.data);
          this.error = this.$t('updatePayment.fetchError');
        }

        // Fetch properties
        console.log('Fetching properties');
        const resultProperties = await axios.get("/data/getallproperty");
        console.log('Properties result:', resultProperties.data);
        if (resultProperties.status === 200 && resultProperties.data.status === 'success') {
          this.properties = resultProperties.data.data || [];
        } else {
          console.error('Properties API failed:', resultProperties.data);
          this.error = this.$t('updatePayment.fetchError');
        }

        // Fetch account payments
        console.log('Fetching account payments');
        const resultAccounts = await axios.get("/data/accountpayment");
        console.log('Accounts result:', resultAccounts.data);
        if (resultAccounts.status === 200 && resultAccounts.data.status === 'success') {
          this.accountpayment = resultAccounts.data.data || [];
        } else {
          console.error('Accounts API failed:', resultAccounts.data);
          this.error = this.$t('updatePayment.fetchError');
        }

        // Fetch contracts and installments/commissions
        if (this.contract.conid) {
          console.log('Fetching contracts and details for conid:', this.contract.conid);
          await this.fetchContractsAndDetails();
        } else {
          console.warn('No contract.conid, skipping fetchContractsAndDetails');
        }
      } catch (err) {
        console.error('Error in mounted:', err);
        this.error = err.response?.data?.message || this.$t('updatePayment.fetchError');
      } finally {
        console.log('Setting isLoading to false');
        this.isLoading = false;
      }
    },
    data() {
      return {
        v$: useValidate(),
        isLoading: false,
        isSubmitting: false,
        error: null,
        renters: [],
        renter: null,
        properties: [],
        property: {},
        comm: "",
        contracts: [],
        contract: {},
        contstatus: "",
        contstart: "",
        conttype: "",
        status: "",

        contduration: "",
        contamount: "",
        methods: [
          { category: "نقدى", value: "cash" },
          { category: "حوالة بنكية", value: "bank transfer" },
          { category: "لحساب المالك", value: "owner account" },
          { category: "شيك", value: "check" },
          { category: "خصم من التامين", value: "insurance discount" },
          { category: "خصم من دفعة مقدمة", value: "discount from advance payment" },
          { category: "عهدة نقدية", value: "monetary contract" },
          { category: "منصة ايجار", value: "igar" },
        ],
        Method: {},
        accountpayment: [],
        account: "",
        paymentdate: "",
        conductor: "",
        commission: [],
        paymentamount: "",
        propertyaccount: "",
        propertytaxaccount: "",
        renteraccount: "",
        totalcommission: 0,
        totalcommissiontax: 0,
        unit: "",
        description: "",
        commissionaccount: "",
        ownerid: "",
        totalrentpayment: 0,
        totalrentpaymenttax: 0,
        installment: [],
        igarnumber: "",
        commissiontype: "",
        periodtime: "",
        installmentnum: "",
        duedate: "",
        change: "",
        paiedinstallments: [],
        fileURL: [],
        newFiles: [],
        igarref: "",
      };
    },
    validations() {
      return {
        renter: { required },
        property: { required },
        contract: { required },
        Method: { required },
        account: { required },
        paymentdate: { required },
      };
    },
    methods: {
      safeParse(jsonString) {
        try {
          return JSON.parse(jsonString);
        } catch (err) {
          console.error('Failed to parse JSON:', jsonString, err);
          return null;
        }
      },
      populatePaymentData(data) {
        console.log('Populating payment data:', data);
        try {
          this.renter = data.renterid && data.rentername ? { renterid: data.renterid, rentername: data.rentername } : null;
          this.property = data.proid && data.proname ? {
            pid: data.proid,
            name: data.proname,
            commission: data.comm || "",
            account: this.safeParse(data.propertyaccount) || {},
            taxaccount: this.safeParse(data.propertytaxaccount) || {},
            commissionaccount: this.safeParse(data.commissionaccount) || {},
            ownerid: data.ownerid || ""
          } : {};
          this.contract = data.conid ? {
            conid: data.conid,
            rentername: data.rentername || "",
            renterid: data.renterid || "",
            unite: data.unit || "",
            status: data.status || "",
            contstart: data.contstart || "",
            conttype: data.type || "",
            contduration: data.periodtime || "",
            contamount: data.amount || "",
            commission: data.commission || "",
            renteraccount: data.renteraccount || "",
            igarnumber: data.igarnumber || "",
            commissiontype: data.commissiontype || ""
          } : {};
          this.contstatus = data.status || "";
           this.contstart = data.contstart || "";
          this.conttype = data.type || "";
          this.contduration = data.periodtime || "";
          this.contamount = data.amount || "";
          this.commissiontype = data.commissiontype || "";
          this.unit = data.unit || "";
          this.description = data.description || "";
          this.paymentdate = data.paydate || "";
          this.conductor = data.conductor || "";
          this.paymentamount = data.payamount || "";
          this.comm = data.comm || "";
          this.ownerid = data.ownerid || "";
          this.igarnumber = data.igarnumber || "";
          this.Method = data.paytype ? this.methods.find(m => m.category === data.paytype) || {} : {};
          this.account = this.safeParse(data.payaccount) || {};
          this.propertyaccount = this.safeParse(data.propertyaccount) || {};
          this.propertytaxaccount = this.safeParse(data.propertytaxaccount) || {};
          this.commissionaccount = this.safeParse(data.commissionaccount) || {};
          this.paiedinstallments = this.safeParse(data.paiedinstallments) || [];
          this.fileURL = this.safeParse(data.fileurl) || [];
          this.newFiles = [];
          this.totalrentpayment = data.payamount || 0;
          this.totalrentpaymenttax = data.paytax || 0;
          this.totalcommission = data.comtotal || 0;
          this.totalcommissiontax = data.comtax || 0;
          this.installmentnum = this.paiedinstallments.length || "";
          this.duedate = this.paiedinstallments[0]?.duedate || "";
          this.change = data.change || "";
          console.log('Payment data populated successfully');
        } catch (err) {
          console.error('Error in populatePaymentData:', err);
          throw new Error('Failed to populate payment data');
        }
      },
      async fetchContractsAndDetails() {
        try {
          console.log('Fetching contracts for pid:', this.property.pid, 'renterid:', this.renter.renterid);
          const contractResult = await axios.get(`/data/getpropertycontracts/${this.property.pid}?renterid=${this.renter.renterid}`);
          console.log('Contracts result:', contractResult.data);
          if (contractResult.status === 200 && contractResult.data.status === 'success') {
            this.contracts = contractResult.data.data || [];
          } else {
            console.error('Contracts API failed:', contractResult.data);
            this.error = this.$t('updatePayment.fetchError');
          }

          console.log('Fetching unit period for pid:', this.property.pid, 'unit:', this.unit);
          const encodedUnit = encodeURIComponent(this.unit);
          const periodResult = await axios.get(`/data/getunitperiod/${this.property.pid}?unit=${encodedUnit}`);
          console.log('Period result:', periodResult.data);
          if (periodResult.status === 200 && periodResult.data.status === 'success' && periodResult.data.data[0]) {
            this.periodtime = periodResult.data.data[0].due || "";
          } else {
            console.error('Period API failed:', periodResult.data);
            this.error = this.$t('updatePayment.fetchError');
          }

          console.log('Fetching installments for conid:', this.contract.conid);
          const installmentResult = await axios.get(`/reports/getallinstallment/${this.contract.conid}`);
          console.log('Installments result:', installmentResult.data);
          if (installmentResult.status === 200 && installmentResult.data.status === 'success') {
            this.installment = (installmentResult.data.data || []).map(item => ({
              ...item,
              check: this.paiedinstallments.some(pi => pi.id === item.id),
              payamount: this.paiedinstallments.find(pi => pi.id === item.id)?.payamount || 0,
            }));
          } else {
            console.error('Installments API failed:', installmentResult.data);
            this.error = this.$t('updatePayment.fetchError');
          }

          console.log('Fetching commissions for conid:', this.contract.conid);
          const commissionResult = await axios.get(`/reports/getallcommissions/${this.contract.conid}`);
          console.log('Commissions result:', commissionResult.data);
          if (commissionResult.status === 200 && commissionResult.data.status === 'success') {
            this.commission = (commissionResult.data.data || []).map(item => ({
              ...item,
              check: item.paied < item.amount,
              paymentamount: item.paied < item.amount ? Number(item.amount - item.paied) : 0,
              taxamount: item.paied < item.amount ? Number((item.amount - item.paied) - (item.amount - item.paied) / Number(1 + '.' + item.tax)).toFixed(2) : 0,
            }));
          } else {
            console.error('Commissions API failed:', commissionResult.data);
            this.error = this.$t('updatePayment.fetchError');
          }
        } catch (err) {
          console.error('Error in fetchContractsAndDetails:', err);
          this.error = err.response?.data?.message || this.$t('updatePayment.fetchError');
        }
      },
      calcommission() {
        console.log('Calculating commissions');
        for (let i = 0; i < this.commission.length; i++) {
          const element = this.commission[i].paymentamount;
          if (element == 0 || element == null) {
            this.commission[i].taxamount = 0;
          }
        }
        this.totalcommission = Number(
          this.commission.reduce((acc, array) => acc + Number(array.paymentamount), 0)
        ).toFixed(2);
        this.totalcommissiontax = Number(
          this.commission.reduce((acc, array) => acc + Number(array.taxamount), 0)
        ).toFixed(2);
        console.log('Commissions calculated:', { totalcommission: this.totalcommission, totalcommissiontax: this.totalcommissiontax });
      },
      async submit() {
        console.log('Submitting form');
        this.v$.$validate();
        if (!this.v$.$error) {
          this.isSubmitting = true;
          // Add new files' metadata to fileURL
          let uploadedFiles = this.$refs.files.files;
          for (let x = 0; x < uploadedFiles.length; x++) {
            const type = uploadedFiles[x].name.split(".");
            this.fileURL.push({ name: uploadedFiles[x].name, type: type[type.length - 1] });
          }
          console.log('Files in fileURL:', this.fileURL);

          Swal.fire({
            title: "تاكيد التحديث",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                const collid = this.collid || this.$route.params.collid;
                console.log('Updating payment for collid:', collid);
                const action = await axios.put(`/data/updatewaitpayment/${collid}`, {
                  username: store.state.randp.username,
                  proid: this.property.pid,
                  proname: this.property.name,
                  conid: this.contract.conid,
                  rentername: this.contract.rentername,
                  renterid: this.contract.renterid,
                  amount: this.paymentamount,
                  paytype: this.Method.category,
                  payaccount: JSON.stringify(this.account),
                  paydate: this.paymentdate,
                  conductor: this.conductor,
                  commission: this.commission,
                  description: this.description,
                  payamount: Number(this.totalrentpayment).toFixed(2),
                  paytax: Number(this.totalrentpaymenttax).toFixed(2),
                  comtotal: Number(this.totalcommission - this.totalcommissiontax).toFixed(2),
                  comtax: Number(this.totalcommissiontax).toFixed(2),
                  collamount: Number((this.totalrentpayment * this.comm) / 100).toFixed(2),
                  renteraccount: this.renteraccount,
                  propertyaccount: JSON.stringify(this.propertyaccount),
                  propertytaxaccount: JSON.stringify(this.propertytaxaccount),
                  commissionaccount: JSON.stringify(this.commissionaccount),
                  totalcommission: this.totalcommission,
                  totalcommissiontax: this.totalcommissiontax,
                  ownerid: this.ownerid,
                  igarnumber: this.igarnumber,
                  commissiontype: this.commissiontype,
                  unit: this.unit,
                  periodtime: this.periodtime,
                  installmentnum: this.installmentnum,
                  duedate: this.duedate,
                  change: this.change,
                  comm: this.comm,
                  paiedinstallments: JSON.stringify(this.paiedinstallments),
                  fileurl: JSON.stringify(this.fileURL),
                });
                console.log('Update payment result:', action.data);
                if (action.data.status === "success") {
                  const id = action.data.data;
                  // Upload new files
                  for (let i = 0; i < this.newFiles.length; i++) {
                    let file = this.newFiles[i];
                    let formData = new FormData();
                    let name = file.name.split(".");
                    let newname =
                      store.state.cnum[0].cnum +
                      "_" +
                      id +
                      "_" +
                      i +
                      "." +
                      name[name.length - 1];
                    console.log('Uploading file:', newname);
                    formData.append("file", file, newname);
                    await axios.patch(`/paymentattach/${i}`, formData);
                  }
                  Swal.fire("تم تحديث سند القبض بنجاح");
                  this.redirectTo({ val: "allpayments" });
                }
              } catch (err) {
                console.error('Error updating payment:', err);
                this.error = err.response?.data?.message || this.$t('updatePayment.updateError');
              } finally {
                this.isSubmitting = false;
              }
            }
          });
        } else {
          console.log('Validation failed');
        }
      },
      cal() {
        console.log('Calculating totals');
        if (this.conttype === "residential") {
          this.totalrentpayment = Number(this.paymentamount).toFixed(2);
          this.totalrentpaymenttax = 0;
        } else {
          this.totalrentpayment = (
            Number(this.paymentamount) -
            Number(this.paymentamount - this.paymentamount / 1.15)
          ).toFixed(2);
          this.totalrentpaymenttax = Number(
            this.paymentamount -
            (this.paymentamount - this.totalcommission) / 1.15
          ).toFixed(2);
        }
        console.log('Totals calculated:', { totalrentpayment: this.totalrentpayment, totalrentpaymenttax: this.totalrentpaymenttax });
      },
      colinstall() {
        console.log('Calculating installments');
        const data = this.installment.filter((x) => x.check === true);
        this.paiedinstallments = data;
        this.installmentnum = data.length;
        this.duedate = data[0]?.duedate || "";
        const total = data
          .reduce((acc, array) => acc + Number(array.payamount), 0)
          .toFixed(2);
        const change = data
          .reduce((acc, array) => acc + Number(array.change), 0)
          .toFixed(2);
        this.change = change - total;
        this.paymentamount = Number(total);
        this.cal();
        console.log('Installments calculated:', { paiedinstallments: this.paiedinstallments, paymentamount: this.paymentamount });
      },
      handleFilesUpload() {
        console.log('Handling file upload');
        let uploadedFiles = this.$refs.files.files;
        for (let i = 0; i < uploadedFiles.length; i++) {
          this.newFiles.push(uploadedFiles[i]);
        }
        console.log('New files added:', this.newFiles);
      },
      removeFile(key, source) {
        console.log('Removing file at index:', key, 'from:', source);
        if (source === 'fileURL') {
          this.fileURL.splice(key, 1);
        } else if (source === 'newFiles') {
          this.newFiles.splice(key, 1);
        }
      },
      ...mapActions(["redirectTo"]),
    },
    watch: {
      contract: {
        handler(newVal, oldVal) {
          if (newVal?.conid && newVal.conid !== oldVal?.conid) {
            console.log('Contract conid changed, fetching details for conid:', newVal.conid);
            this.fetchContractsAndDetails();
          } else {
            console.warn('Contract changed but no new conid, skipping fetchContractsAndDetails');
          }
        },
        deep: true
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  .page {
    direction: v-bind("css.EN");
    padding: 0.5%;
  }
  .main {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    padding: 1%;
  }
  .body {
    padding: 1%;
  }
  .body1 {
    padding: 1%;
    width: 100%;
    min-height: 100px;
    border: 1px solid black;
    display: flex;
    border-radius: 5px;
  }
  .group {
    width: 70%;
  }
  .group input,
  .group select {
    width: 80%;
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
    text-align: center;
  }
  .head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
  }
  .head1 {
    width: 60%;
  }
  .head2 {
    width: 40%;
    text-align: center;
  }
  .buttonconfirm {
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
    font-size: small;
    width: 10%;
  }
  .buttonconfirm:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  .error {
    color: red;
    margin-bottom: 15px;
  }
  .error-feedback {
    color: red;
  }
  .option {
    text-align: center;
  }
  table tbody td input,
  table tbody td select {
    border-radius: 3px;
    background-color: #eee;
    text-align: center;
    height: 25px;
    font-size: small;
  }
  </style>
  <i18n>
  {
    "en": {
      "edit": "Edit",
      "updatePayment": {
        "noData": "No payment data found",
        "fetchError": "Failed to fetch payment details. Please try again.",
        "updateError": "Failed to update payment details. Please try again.",
        "invalidCollid": "Invalid payment ID"
      }
    },
    "ar": {
      "edit": "تعديل",
      "updatePayment": {
        "noData": "لم يتم العثور على بيانات الدفع",
        "fetchError": "فشل جلب تفاصيل الدفع. حاول مرة أخرى.",
        "updateError": "فشل تحديث تفاصيل الدفع. حاول مرة أخرى.",
        "invalidCollid": "معرف الدفع غير صالح"
      }
    }
  }
  </i18n>
